// these aren't really redux actions but are tightly bound to the site module, so trying this concept
// these are for things that are purely route-based actions (list/new/edit/cancel etc) can be grouped here
import { getRouter } from '../routing/route-base';

export function newSiteRoute(sport, parentSite) {
    const router = getRouter();
    if (parentSite) {
        router.navigateByName('child-site-new', { parent: parentSite, sport });
    } else {
        router.navigateByName('site-new', { sport });
    }
}

export function siteDetailRoute(sport, site, parentSite) {
    const router = getRouter();
    if (parentSite) {
        router.navigateByName('child-site-detail', {
            parent: parentSite,
            sport,
            site,
        });
    } else {
        router.navigateByName('site-detail', { site, sport });
    }
}

export function siteListRoute(sport, parentSite) {
    const router = getRouter();
    if (parentSite) {
        router.navigateByName('child-site-list', { parent: parentSite, sport });
    } else {
        router.navigateByName('site-list', { sport });
    }
}
